var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompletedProject(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5091 20.925L15.9883 21.575L18.0716 23.2416C18.1466 23.3 18.2383 23.3333 18.3299 23.3333C18.3466 23.3333 18.3633 23.3333 18.3799 23.3333C18.4883 23.3208 18.5924 23.2625 18.6591 23.175L23.2424 17.3416L22.5883 16.825L18.2633 22.3291L16.5091 20.925Z",
    fill: "#74E7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3802 14.6001L20.4552 13.7709C20.1552 13.7417 19.8469 13.7417 19.5469 13.7709L19.6219 14.6001C19.8719 14.5792 20.1302 14.5792 20.3802 14.6001Z",
    fill: "#74E7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8365 14.7083L18.6573 13.8958C16.2781 14.4166 14.4073 16.2916 13.8906 18.6624L14.7031 18.8416C15.1531 16.7833 16.774 15.1624 18.8365 14.7083Z",
    fill: "#74E7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7109 21.1626L13.8984 21.3418C14.4151 23.7168 16.2859 25.5876 18.6651 26.1084L18.8443 25.2959C16.7818 24.8418 15.1609 23.2209 14.7109 21.1626Z",
    fill: "#74E7FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 20C14.5833 19.8667 14.5833 19.7375 14.5958 19.6083L13.7625 19.5583C13.7542 19.7042 13.75 19.85 13.75 20C13.75 20.15 13.7542 20.2958 13.7625 20.4417L14.5958 20.3917C14.5875 20.2625 14.5833 20.1333 14.5833 20Z",
    fill: "#74E7FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4148 20C25.4148 20.1333 25.4148 20.2625 25.4023 20.3917L26.2357 20.4417C26.244 20.2958 26.2482 20.15 26.2482 20C26.2482 19.85 26.244 19.7042 26.2357 19.5583L25.4023 19.6083C25.4107 19.7375 25.4148 19.8667 25.4148 20Z",
    fill: "#74E7FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1641 25.2917L21.3432 26.1042C23.7224 25.5833 25.5932 23.7083 26.1099 21.3375L25.2974 21.1583C24.8474 23.2167 23.2266 24.8375 21.1641 25.2917Z",
    fill: "#74E7FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3393 13.8916L21.1602 14.7041C23.2227 15.1583 24.8435 16.7791 25.2935 18.8374L26.106 18.6583C25.5893 16.2833 23.7185 14.4124 21.3393 13.8916Z",
    fill: "#74E7FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6219 25.3999L19.5469 26.2291C19.6969 26.2416 19.8469 26.2457 20.001 26.2457C20.1552 26.2457 20.3052 26.2416 20.4552 26.2291L20.3802 25.3999C20.1302 25.4207 19.8719 25.4207 19.6219 25.3999Z",
    fill: "#74E7FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20 7.5C13.1083 7.5 7.5 13.1083 7.5 20C7.5 26.8917 13.1083 32.5 20 32.5C26.8917 32.5 32.5 26.8917 32.5 20C32.5 13.1083 26.8917 7.5 20 7.5ZM18.0083 30.2583L19.1042 31.625C13.1542 31.1708 8.44167 26.2333 8.34167 20.1917L10.0042 18.8625L11.6833 20.2042C11.7875 24.4208 15.0375 27.875 19.1708 28.2875L18.0125 29.7375C17.8917 29.8917 17.8917 30.1042 18.0125 30.2583H18.0083ZM20 27.5C15.8667 27.5 12.5 24.1333 12.5 20C12.5 15.8667 15.8667 12.5 20 12.5C24.1333 12.5 27.5 15.8667 27.5 20C27.5 24.1333 24.1333 27.5 20 27.5ZM31.6583 20.3417L30 21.6667L28.3167 20.3208C28.3167 20.2125 28.3333 20.1083 28.3333 20C28.3333 15.5125 24.7667 11.8542 20.3208 11.6833L21.6667 10L20.3417 8.34167C26.6167 8.52083 31.6667 13.6792 31.6667 20C31.6667 20.1125 31.6625 20.225 31.6583 20.3417Z",
    fill: "#74E7FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedProject);
export default __webpack_public_path__ + "static/media/completedProject.6bcaafc336a38645ddcbb908fde7cbfc.svg";
export { ForwardRef as ReactComponent };